import { z } from "zod";
import { uuidSchema } from "./common.js";
export const aircraftRegistrationSchema = z
    .string()
    .trim()
    .min(1)
    .max(20)
    .regex(/^[A-Za-z0-9\-]+$/, "Nur Buchstaben, Zahlen und Bindestrich erlaubt");
export const createAircraftSchema = z.object({
    registration: aircraftRegistrationSchema,
    typeId: uuidSchema,
    active: z.boolean().default(true),
});
export const updateAircraftSchema = z.object({
    registration: aircraftRegistrationSchema.optional(),
    typeId: uuidSchema.optional(),
    active: z.boolean().optional(),
});
export const aircraftTypeNameSchema = z.string().trim().min(1).max(80);
export const createAircraftTypeSchema = z.object({
    name: aircraftTypeNameSchema,
    active: z.boolean().default(true),
});
export const updateAircraftTypeSchema = z.object({
    name: aircraftTypeNameSchema.optional(),
    active: z.boolean().optional(),
});
//# sourceMappingURL=aircraft.js.map